/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum SearchLocation {
  Amas = "Amas",
  Articles = "Articles",
  Athletes = "Athletes",
  Experiences = "Experiences",
  Home = "Home",
  Memorabilia = "Memorabilia",
  Merch = "Merch",
  Organizations = "Organizations",
  Products = "Products",
  Streams = "Streams",
}

export enum SearchResultType {
  Articles = "Articles",
  Athlete = "Athlete",
  ContentCreator = "ContentCreator",
  Experience = "Experience",
  MediaPost = "MediaPost",
  Memorabilia = "Memorabilia",
  Merch = "Merch",
  Organization = "Organization",
  Product = "Product",
  Stream = "Stream",
}

/** Opaque view event codes – do not document meaning */
export enum ViewEventCode {
  V_A = "V_A",
  V_B = "V_B",
  V_C = "V_C",
  V_D = "V_D",
  V_E = "V_E",
}

export enum AnalyticsTargetType {
  MEDIA_POST = "MEDIA_POST",
  PROFILE = "PROFILE",
}

export interface SearchInput {
  term: string;
  location: SearchLocation;
  searchResult?: SearchResultInput | null;
}

export interface SearchResultInput {
  srType: SearchResultType;
  srId: string;
}

export interface ViewEventInput {
  targetId: string;
  viewCode: ViewEventCode;
}

/**
 * Track views input - supports batch operations
 */
export interface TrackViewsInput {
  targetType: AnalyticsTargetType;
  views: ViewEventInput[];
}

//==============================================================
// END Enums and Input Objects
//==============================================================
